import { ProductQuery } from '../types/types';
import { getBulkProductSizes } from '../apis/products';

export default function injectSizesIntoProductList(products: ProductQuery[]) {
  return getBulkProductSizes(products.map(p => p.productId)).then(res => {
    const groupedSize = {};

    res.data.payload.forEach(size => {
      // @ts-ignore
      if (!groupedSize[size.productId]) groupedSize[size.productId] = [];
      // @ts-ignore
      groupedSize[size.productId].push(size);
    });

    products.forEach(product => {
      // @ts-ignore
      product.productSizes = groupedSize[product.productId]
    });

    return products;
  });
}
